var AIService, ChapterDoc, DOCUMENT_SECTIONS_V2_SECTION_TYPE, DbHelper, HANDOUTS_SECTIONS_MAPPING, MDA_HANDOUT, MINI_DS_SECTION_PREFIX, MdaTopicDoc, MiniDSDoc, PMModel, SectionDoc, W, addContentToSection, ajax, callHandoutsApi, callMethod, concatReducer, fetchHandout, fetchTopic, findOrCreateSectionByChapterTitle, flatPluckCompact, generateGUID, get, getContentPromise, getSchema, handoutChaptersView, mediator, pluckDocsIndexById, processList, processSection, processTopicChapter, sequence, topicChaptersView, topicSectionsView, _ref, _ref1;

ajax = require('actions/async/api_helpers').ajax;

_ref = require('base/lib/utils'), callMethod = _ref.callMethod, generateGUID = _ref.generateGUID;

ChapterDoc = require('lib/db_docs/document_sections_v2_chapter_doc');

DbHelper = require('base/lib/db_helper');

_ref1 = require('lib/db_docs/doc_types'), DOCUMENT_SECTIONS_V2_SECTION_TYPE = _ref1.DOCUMENT_SECTIONS_V2_SECTION_TYPE, MDA_HANDOUT = _ref1.MDA_HANDOUT;

flatPluckCompact = require('lib/app_utils').flatPluckCompact;

get = require('lodash').get;

getContentPromise = require('lib/services/document_sections_exporter/utils').getContentPromise;

getSchema = Epiditor.getSchema, PMModel = Epiditor.PMModel;

MdaTopicDoc = require('lib/db_docs/mda_topic_doc');

MiniDSDoc = require('lib/db_docs/mini_ds_doc');

MINI_DS_SECTION_PREFIX = require('lib/doc_prefixes').miniDSSectionDoc;

mediator = require('mediator');

SectionDoc = require('lib/db_docs/document_sections_v2_section_doc');

sequence = require('when/sequence');

W = require('when/when');

handoutChaptersView = {
  map: function(doc) {
    if (doc.type === 'document_sections_chapter') {
      return emit(doc.parentDocId, doc);
    }
  }
};

topicChaptersView = {
  map: function(doc) {
    if (doc.type === 'document_sections_chapter') {
      return emit(doc.mdaTopicId, doc);
    }
  }
};

topicSectionsView = {
  map: function(doc) {
    if (doc.type === 'document_sections_section') {
      return emit(doc.mdaTopicId, doc);
    }
  }
};

pluckDocsIndexById = function(rows) {
  return _.chain(rows).pluck('doc').compact().indexBy('_id').value();
};

fetchHandout = function(adapter, projectId, mdaHandoutId) {
  var chaptersPromise, handoutPromise;
  handoutPromise = MiniDSDoc.at(mediator.project.id, mdaHandoutId).fetch();
  chaptersPromise = adapter.fetchWithView(projectId, 'handoutChaptersView', handoutChaptersView, mdaHandoutId);
  return W.all([handoutPromise, chaptersPromise]).then(function(_arg) {
    var chapters, handout, sectionIds;
    handout = _arg[0], chapters = _arg[1];
    sectionIds = flatPluckCompact(chapters, 'sections');
    return adapter.fetch(projectId, sectionIds).then(function(_arg1) {
      var rows, sections;
      rows = _arg1.rows;
      sections = pluckDocsIndexById(rows);
      return {
        chapters: chapters,
        handout: handout,
        sections: sections
      };
    });
  });
};

fetchTopic = function(adapter, projectId, topicId) {
  return MdaTopicDoc.at(projectId, topicId).fetch().then(function(topic) {
    var chaptersPromise, rootPromise, sectionsPromise, tablesPromise;
    rootPromise = adapter.fetch(projectId, topic.topicRootId);
    chaptersPromise = adapter.fetchWithView(projectId, 'chaptersV2', topicChaptersView, topicId);
    sectionsPromise = adapter.fetchWithView(projectId, 'sectionsV2', topicSectionsView, topicId);
    tablesPromise = _.isEmpty(topic.insertedTables) ? W.resolve([]) : adapter.fetch(projectId, topic.insertedTables);
    return W.all([rootPromise, chaptersPromise, sectionsPromise, tablesPromise]).then(function(_arg) {
      var chapters, chaptersDocs, rootDoc, sections, sectionsDocs, tables, tablesRows, _ref2;
      rootDoc = _arg[0], chaptersDocs = _arg[1], sectionsDocs = _arg[2], (_ref2 = _arg[3], tablesRows = _ref2.rows);
      tables = pluckDocsIndexById(tablesRows);
      chapters = _.indexBy(chaptersDocs, '_id');
      sections = _.indexBy(sectionsDocs, '_id');
      return {
        chapters: chapters,
        rootDoc: rootDoc,
        sections: sections,
        tables: tables,
        topic: topic
      };
    });
  });
};

processSection = function(_arg) {
  var content, section, sectionId, sections, tableDoc, tables, title, _ref2, _ref3, _ref4, _ref5, _ref6;
  sectionId = _arg.sectionId, sections = _arg.sections, tables = _arg.tables;
  section = sections[sectionId];
  if (section == null) {
    return W.resolve(null);
  }
  _ref6 = section.mdaTableId ? (tableDoc = tables[section.mdaTableId], [(_ref2 = tableDoc != null ? tableDoc.content : void 0) != null ? _ref2 : '', (_ref3 = tableDoc != null ? tableDoc.name : void 0) != null ? _ref3 : '']) : [(_ref4 = section.content) != null ? _ref4 : '', (_ref5 = section.title) != null ? _ref5 : ''], content = _ref6[0], title = _ref6[1];
  return getContentPromise("section_" + sectionId, content).then(function(htmlContent) {
    if (_.isEmpty(htmlContent)) {
      return null;
    } else {
      return "<h3>" + title + "</h3>\n" + htmlContent;
    }
  });
};

concatReducer = function(acc, item) {
  return "" + acc + "\n" + item;
};

processTopicChapter = function(_arg) {
  var chapter, chapterId, chapters, sections, sectionsInChapter, sectionsPromise, subchapters, subchaptersPromise, tables;
  chapterId = _arg.chapterId, chapters = _arg.chapters, sections = _arg.sections, tables = _arg.tables;
  chapter = chapters[chapterId];
  if (chapter == null) {
    return W.resolve(null);
  }
  subchapters = chapter.subchapters || [];
  sectionsInChapter = chapter.sections || [];
  subchaptersPromise = sequence(_.map(subchapters, function(subchapterId) {
    return function() {
      return processTopicChapter({
        chapterId: subchapterId,
        chapters: chapters,
        sections: sections,
        tables: tables
      });
    };
  }));
  sectionsPromise = sequence(_.map(sectionsInChapter, function(sectionId) {
    return function() {
      return processSection({
        sectionId: sectionId,
        sections: sections,
        tables: tables
      });
    };
  }));
  return W.all([subchaptersPromise, sectionsPromise]).then(function(_arg1) {
    var sectionsResults, subchaptersResults, text;
    subchaptersResults = _arg1[0], sectionsResults = _arg1[1];
    text = _.chain(sectionsResults).union(subchaptersResults).compact().reduce(concatReducer, '').value();
    return "<h2>" + chapter.title + "</h2>\n<div>" + text + "</div>";
  });
};

findOrCreateSectionByChapterTitle = function(chapters, sections, title) {
  var chapter, newId, section, sectionId;
  chapter = _.find(chapters, function(chapter) {
    return chapter.title === title;
  });
  if (!chapter) {
    throw new Error('No chapter with given title');
  }
  sectionId = _.first(chapter.sections);
  section = sectionId ? sections[sectionId] : null;
  if (section == null) {
    newId = "" + MINI_DS_SECTION_PREFIX + (generateGUID());
    return SectionDoc.at(mediator.project.id, newId).create({
      _id: newId,
      mdaTopicId: chapter.mdaTopicId,
      parent: chapter._id,
      title: '',
      content: '',
      type: DOCUMENT_SECTIONS_V2_SECTION_TYPE
    }).then(function(section) {
      return ChapterDoc.at(mediator.project.id, chapter._id).updateAsInstance(callMethod('addSections', [newId])).then(function() {
        sections[newId] = section;
        return section;
      });
    });
  } else {
    return W.resolve(section);
  }
};

processList = function(div, response) {
  var item, li, ul, _i, _len;
  ul = document.createElement('ul');
  for (_i = 0, _len = response.length; _i < _len; _i++) {
    item = response[_i];
    li = document.createElement('li');
    li.textContent = item;
    ul.appendChild(li);
  }
  return div.appendChild(ul);
};

addContentToSection = function(section, sectionMapping, response) {
  var content, div, node, noteP, noteText, p, responseList, timeline, timelines, titleH4, _i, _len;
  div = document.createElement('div');
  switch (sectionMapping.responseType) {
    case 'text':
      p = document.createElement('p');
      p.textContent = get(response, sectionMapping.responsePath, '');
      div.appendChild(p);
      break;
    case 'list':
      responseList = get(response, sectionMapping.responsePath, []);
      processList(div, responseList);
      break;
    case 'list_with_note':
      responseList = get(response, sectionMapping.responsePath, []);
      processList(div, responseList);
      noteText = get(response, sectionMapping.notePath, '');
      if (noteText != null) {
        noteP = document.createElement('p');
        noteP.textContent = noteText;
        noteP.style.fontStyle = 'italic';
        div.appendChild(noteP);
      }
      break;
    case 'list_of_timelines':
      timelines = get(response, sectionMapping.responsePath, []);
      for (_i = 0, _len = timelines.length; _i < _len; _i++) {
        timeline = timelines[_i];
        titleH4 = document.createElement('h4');
        titleH4.textContent = timeline.title;
        div.appendChild(titleH4);
        processList(div, timeline.recovery_times_entries.map(function(entry) {
          return "" + entry.activity_type + ": " + entry.duration;
        }));
      }
  }
  node = PMModel.DOMParser.fromSchema(getSchema()).parse(div);
  content = {
    doc: node.toJSON(),
    selection: {
      type: 'text',
      anchor: 0,
      head: 0
    },
    changeTracker: {
      changes: {}
    },
    annotations: {}
  };
  div.remove();
  return SectionDoc.at(mediator.project.id, section._id).updateAsInstance(callMethod('setProperty', 'content', content));
};

HANDOUTS_SECTIONS_MAPPING = [
  {
    chapterTitle: 'Overview',
    responsePath: 'overview',
    responseType: 'text'
  }, {
    chapterTitle: 'Recovery Expectations',
    responsePath: 'recovery_expectations',
    responseType: 'text'
  }, {
    chapterTitle: 'What to Consider',
    responsePath: 'what_to_consider',
    responseType: 'list'
  }, {
    chapterTitle: 'What to Do',
    responsePath: 'returning_to_activity.to_do',
    responseType: 'list'
  }, {
    chapterTitle: 'What to Avoid',
    responsePath: 'returning_to_activity.to_avoid',
    responseType: 'list'
  }, {
    chapterTitle: 'What to Adjust',
    responsePath: 'returning_to_activity.to_adjust',
    responseType: 'list'
  }, {
    chapterTitle: 'Checklist for Healing',
    responsePath: 'checklist_for_healing.recovery_checklist',
    notePath: 'checklist_for_healing.remember_note',
    responseType: 'list_with_note'
  }, {
    chapterTitle: 'Return to Activity Timeline',
    responsePath: 'recovery_times',
    responseType: 'list_of_timelines'
  }
];

callHandoutsApi = function(text, title) {
  return ajax({
    contentType: 'application/json',
    data: JSON.stringify({
      text: text,
      title: title
    }),
    dataType: 'json',
    type: 'POST',
    url: "" + (DbHelper.getBackendUrl()) + "/ai/handouts/" + mediator.project.id + "/_generate",
    xhrFields: {
      withCredentials: true
    }
  });
};

module.exports = AIService = (function() {
  function AIService(adapter) {
    this.adapter = adapter;
  }

  AIService.prototype.generateHandoutContent = function(mdaHandoutId) {
    return fetchHandout(this.adapter, mediator.project.id, mdaHandoutId).then((function(_this) {
      return function(_arg) {
        var chapters, handout, sections, _ref2;
        chapters = _arg.chapters, handout = _arg.handout, sections = _arg.sections;
        if ((handout != null ? handout.docType : void 0) !== MDA_HANDOUT) {
          throw new Error('Unsupported type');
        }
        if (!(handout != null ? (_ref2 = handout.options) != null ? _ref2.parentTopicId : void 0 : void 0)) {
          throw new Error('No topic id');
        }
        return fetchTopic(_this.adapter, mediator.project.id, handout.options.parentTopicId).then(function(topicData) {
          var _ref3;
          return sequence(_.map((_ref3 = topicData.rootDoc.chaptersOrder) != null ? _ref3 : [], function(chapterId) {
            return function() {
              return processTopicChapter({
                chapterId: chapterId,
                chapters: topicData.chapters,
                sections: topicData.sections,
                tables: topicData.tables
              });
            };
          })).then(function(chapterContents) {
            var fullContent, fullText;
            fullContent = _.chain(chapterContents).compact().reduce(concatReducer, '').value();
            fullText = "<h1>" + topicData.topic.name + "</h1>\n" + fullContent;
            return callHandoutsApi(fullText, topicData.topic.name);
          });
        }).then(function(response) {
          return sequence(_.map(HANDOUTS_SECTIONS_MAPPING, function(sectionMapping) {
            return function() {
              return findOrCreateSectionByChapterTitle(chapters, sections, sectionMapping.chapterTitle).then(function(section) {
                return addContentToSection(section, sectionMapping, response);
              });
            };
          }));
        });
      };
    })(this));
  };

  return AIService;

})();
